import type { ApolloError } from '@apollo/client'
import {
  GetRoleLegalEntitiesDocument,
  GetRoleLegalEntitiesQuery,
} from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

export type LegalEntities = NonNullable<
  GetRoleLegalEntitiesQuery['jobCatalog']['role']
>['legalEntities']

type Return = [LegalEntities | undefined, boolean, () => void, ApolloError | undefined]

export const useRoleLegalEntities = (id: number): Return => {
  const { data, loading, refetch, error } = useQuery(GetRoleLegalEntitiesDocument, {
    variables: { id },
  })

  const role = !loading ? data?.jobCatalog.role?.legalEntities : undefined

  return [role, loading, refetch, error]
}
